import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { DEALER_INFO } from 'constants/endpoints.api';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { DealerResponse } from './types';

interface GetDealerInfoQueryParams {
  storeId: string;
  locale: string;
}

export const useGetDealerInfoQuery = ({
  storeId,
  locale
}: GetDealerInfoQueryParams) =>
  useQuery<DealerResponse>({
    queryKey: ['dealer-info', storeId, locale],
    queryFn: async () => {
      const url = getRelativeURLWithParams(DEALER_INFO, { storeId, locale });

      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      return res.json();
    },
    enabled: !!storeId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false
  });
